export const FloatingComponent = (props) => {
  return (
    <div className="floating-component">
      {/* Hier kommt Ihr Inhalt für die FloatingComponent */}
      {props.children}
    </div>
  );
}